<template>
  <!-- DealerSalesPanel — Panel 4: 딜러 출고 - REQ-FE-TRC-003~005 -->
  <!-- SPEC-CHINA-LOT-FLOW-DASHBOARD-001 REQ-FE-DETAIL-006,008: 확장 필드 + 누적 출고율 -->
  <a-card class="lot-trace-panel" :loading="loading">
    <template #title>
      <span>{{ $t('lotTrace_panel_dealerSales') }}</span>
      <a-badge
        :count="panelData.count"
        :overflow-count="999"
        :style="{ marginLeft: '8px', backgroundColor: panelData.count > 0 ? '#52c41a' : '#d9d9d9' }"
      />
      <span v-if="panelData.truncated" style="font-size: 12px; color: #faad14; margin-left: 8px;">
        {{ $t('lotTrace_truncated') }}
        ({{ $t('dealerGsp_total_count', { count: panelData.preCapTotal }) }})
      </span>
      <!-- REQ-FE-DETAIL-008: 누적 출고율 패널 헤더에 표시 -->
      <span
        v-if="cumulativeSalesRate !== null && cumulativeSalesRate !== undefined"
        style="margin-left: 12px; font-size: 13px; color: #595959;"
        data-testid="cumulative-sales-rate"
      >
        {{ $t('lotFlow_detail_cumulativeSalesRate') }}: <strong>{{ formatPercent(cumulativeSalesRate) }}</strong>
      </span>
    </template>
    <template #extra>
      <a-button v-if="value" type="link" size="small" @click="viewAll">{{ $t('lotTrace_actions_viewAll') }}</a-button>
    </template>

    <template v-if="loading">
      <a-skeleton active :paragraph="{ rows: 3 }" />
    </template>
    <template v-else-if="panelData.count === 0">
      <a-empty :description="emptyMessage" />
    </template>
    <template v-else>
      <div style="overflow-x: auto;">
        <a-table
          :data-source="panelData.rows"
          :columns="columns"
          :pagination="false"
          row-key="_id"
          size="small"
          :scroll="{ x: 1000 }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'batchNumber'">
              <a-button
                type="link"
                size="small"
                style="padding: 0; min-height: 44px; height: auto;"
                @click="deepLinkToSource(record.batchNumber)"
              >{{ record.batchNumber || '-' }}</a-button>
            </template>
            <template v-else-if="column.key === 'deliveryDate'">
              {{ formatDate(record.deliveryDate) }}
            </template>
            <!-- REQ-FE-DETAIL-006: 확장 필드 -->
            <template v-else-if="column.key === 'voucherCode'">
              <span class="code-mono">{{ record.voucherCode || '-' }}</span>
            </template>
            <template v-else-if="column.key === 'unitPrice'">
              {{ record.unitPrice != null ? record.unitPrice.toLocaleString() : '-' }}
            </template>
          </template>
        </a-table>
      </div>
    </template>
  </a-card>
</template>

<script>
export default {
  name: 'DealerSalesPanel',
  props: {
    panelData: { type: Object, default: () => ({ count: 0, preCapTotal: 0, truncated: false, rows: [] }) },
    loading: { type: Boolean, default: false },
    value: { type: String, default: '' },
    anomalies: { type: Array, default: () => [] },
    // REQ-FE-DETAIL-008: 누적 출고율
    cumulativeSalesRate: { type: Number, default: null },
  },
  emits: ['navigate'],
  computed: {
    columns() {
      return [
        { title: this.$t('lotTrace_col_batchNumber'), dataIndex: 'batchNumber', key: 'batchNumber', width: 170 },
        { title: this.$t('lotTrace_col_deliveryDate'), dataIndex: 'deliveryDate', key: 'deliveryDate', width: 130 },
        { title: this.$t('lotTrace_col_productCode'), dataIndex: 'productCode', key: 'productCode', width: 130 },
        { title: this.$t('lotTrace_col_customerName'), dataIndex: 'customerName', key: 'customerName', width: 160, ellipsis: true },
        { title: this.$t('lotTrace_col_quantity'), dataIndex: 'quantity', key: 'quantity', width: 80, align: 'right' },
        // 확장 필드
        { title: this.$t('lotFlow_detail_field_voucherCode'), dataIndex: 'voucherCode', key: 'voucherCode', width: 150 },
        { title: this.$t('lotFlow_detail_field_customerCode'), dataIndex: 'customerCode', key: 'customerCode', width: 120 },
        { title: this.$t('lotFlow_detail_field_unitPrice'), dataIndex: 'unitPrice', key: 'unitPrice', width: 100, align: 'right' },
      ];
    },
    emptyMessage() {
      const match = (this.anomalies || []).find((a) =>
        ['not_found', 'missing_dealer_sales'].includes(a.type)
      );
      if (match) {
        const key = match.type === 'not_found'
          ? 'lotTrace_anomaly_not_found'
          : 'lotTrace_anomaly_missing_dealer_sales';
        return this.$t(key);
      }
      return this.$t('lotTrace_emptyState');
    },
  },
  methods: {
    formatDate(val) {
      if (!val) return '-';
      const d = new Date(val);
      if (isNaN(d)) return val;
      return d.toLocaleDateString('zh-CN', { timeZone: 'Asia/Shanghai' });
    },
    formatPercent(val) {
      if (val === null || val === undefined) return '-';
      return (val * 100).toFixed(1) + '%';
    },
    viewAll() {
      if (!this.value) return;
      this.$emit('navigate', `/dealer-gsp/sales-outbounds?batchNumber=${encodeURIComponent(this.value)}`);
    },
    deepLinkToSource(batchNumber) {
      if (!batchNumber) return;
      this.$emit('navigate', `/dealer-gsp/sales-outbounds?batchNumber=${encodeURIComponent(batchNumber)}`);
    },
  },
};
</script>

<style scoped>
.code-mono {
  font-family: "SF Mono", "Cascadia Mono", Menlo, monospace;
  font-size: 12px;
}
</style>
